export default {
    'create-custom-statement': 'Create customised statement',
    'edit-custom-statement': 'Edit customised statement',
    'custom-statement-name': 'Customised statement name',
    'accounts': 'Accounts',
    save: 'Save',
    cancel: 'Cancel',
    'delete-the-custom-statement': 'Delete customised statement',
    'are-you-sure-you-want-to-delete-the-custom-statement': 'Do you want to delete this customised statement?',

    headers: {
        'custom-statement-name': 'Customised statement name',
        'used-accounts': 'Related accounts',
        'actions': 'Actions',
    }
}